import React, { useState } from "react";

import RetentionSetting from "./retention/RetentionSetting";
import StreamSetting from "./streaming/StreamSetting";
import RetentionDurationTabs from "./RetentionDurationTabs";

type ActiveTab = "retention" | "streaming";

const RetentionDuration: React.FC = () => {
  const [activeTab, setActiveTab] = useState<ActiveTab>("retention");

  return (
    <div className="max-w-screen w-full min-h-screen">
      <div className="w-full max-w-full lg:p-4 md:p-4 p-4">
        <div className="mb-6">
          <h2 className="text-2xl font-semibold text-gray-900 mb-6">
            Retention Duration
          </h2>
        </div>

        <RetentionDurationTabs activeTab={activeTab} onChange={setActiveTab} />

        {activeTab === "retention" ? <RetentionSetting /> : <StreamSetting />}
      </div>
    </div>
  );
};

export default RetentionDuration;
